import { connect } from 'react-redux'
import { push, replace, goBack } from 'react-router-redux'

import Search from './Search'
import * as fromSearch from '@src/redux/modules/search'
import * as fromBookingSetup from '@src/redux/modules/bookingSetup'
import * as fromService from '@src/redux/modules/service'

const mapStateToProps = (state, ownProps) => {
  return {
    searching: fromSearch.isSearching(state),
    searchingMyAliadas: fromSearch.isSearchingMyAliadas(state),
    results: fromSearch.getAvailableAliadas(state),
    status: fromSearch.getStatus(state),
    myAliadasResults: fromSearch.getAvailableMyAliadas(state)
  }
}

const mapDispatchToProps = {
  search: fromSearch.search,
  searchMyAliadas: fromSearch.searchMyAliadas,
  updateServiceSetup: fromBookingSetup.update,
  updateService: fromService.updateNewService,
  push,
  replace,
  goBack
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Search/SearchContainer.js